import { InjectionToken } from '@angular/core';

export const TRANSLATION_URL_TOKEN = new InjectionToken<string>('translation service url');
